import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UblLinkComponent } from './ubl-link/ubl-link.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [UblLinkComponent],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [UblLinkComponent]
})
export class Link2Module { }
